import type { Operator } from "./index.js"

// fieldValue is an array; conditionValue is a single entry.

export const includes: Operator = {
  key: "includes",
  label: "includes",
  icon: "circle-check",
  value: "scalar",
  fn: (a, b) => Array.isArray(a) && a.includes(b),
}

export const notIncludes: Operator = {
  key: "notIncludes",
  label: "does not include",
  icon: "list",
  value: "scalar",
  // Null-excluding, matching `NOT (col @> ...)`. See notEquals in equality.ts.
  fn: (a, b) => a != null && (!Array.isArray(a) || !a.includes(b)),
}
